import { EllipsisText, type GridColDef } from '@shared/components';

export interface ExamCenterListItem {
  id: string;
  examCenterId: number;
  code: string;
  nameTH: string;
  nameEN: string;
}

export const columns: GridColDef<ExamCenterListItem>[] = [
  {
    field: 'examCenterId',
    headerName: 'ID',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
    width: 100,
  },
  {
    field: 'code',
    headerName: 'Code',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
    width: 120,
    renderCell: ({ row }) => {
      return <EllipsisText variant='body1Semibold'>{row.code}</EllipsisText>;
    },
  },
  {
    field: 'nameTH',
    headerName: 'Name (TH)',
    sortable: false,
    flex: 1,
    renderCell: ({ row }) => {
      return <EllipsisText variant='body1Semibold'>{row.nameTH}</EllipsisText>;
    },
  },
  {
    field: 'nameEN',
    headerName: 'Name (EN)',
    sortable: false,
    flex: 1,
    renderCell: ({ row }) => {
      return <EllipsisText variant='body1Semibold'>{row.nameEN}</EllipsisText>;
    },
  },
];
